import { useState } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'
import { requestScamReport } from '../../service/MainService';
import { toast } from 'react-toastify';


export default function ScamAlertRequestModal({ open, setOpen, userDetails }) {
    const cancelButtonRef = useRef(null)
    const [message, setMessage] = useState('');
    
    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
          const token = localStorage.getItem("accessToken");
          const userId = parseInt(localStorage.getItem("userId"), 10)
          const userName = localStorage.getItem("name");
          const reportData = {
            ReporterDetails:{
                ReporterId: userDetails.UserId,
                ReporterName: userDetails.Name
            },
          
            user: {
                UserId: userId,
                UserName:userName
            },
            Message: message
        };
      
          const response = await requestScamReport(reportData, token);
    
          if (response) {
            toast.success("Account is Reported");
            setOpen(false)
          }
        } catch (error) {
          console.error("Submission error:", error);
          toast.error(error.message || "Something went wrong");
        }
      };


    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <form onSubmit={handleSubmit}>
                                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                        <div>
                                            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                                <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900 mb-5">
                                                    Report
                                                </Dialog.Title>
                                                <div className="mt-2">
                                                    <label className="block text-sm font-medium leading-6 text-gray-900">
                                                        Reason <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="mt-2">
                                                    <input
                                                            className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border-2 border-gray-400 focus:border-purple-500 focus:outline-purple rounded-lg"
                                                            value={message}
                                                            onChange={(e) => setMessage(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex flex-col items-center gap-5 justify-center text-sm mt-5 font-semibold">
                                                    <p>Are you sure you want to continue?</p>
                                                    <div className='flex items-center gap-4'>
                                                        <button
                                                            type="button"
                                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-800 sm:ml-3 sm:w-auto"
                                                            onClick={() => setOpen(false)}
                                                            ref={cancelButtonRef}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-800 sm:ml-3 sm:w-auto"

                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
